
//腾讯视频 LicenseUrl
export  const TXLicenseUrl = 'https://license.vod2.myqcloud.com/license/v2/1321573871_1/v_cube.license'